export const NotificationTypes = Object.freeze({
	RELEASE_NOTES: 1,
	NEW_MEDIA_CONTENT: 2,
	TASK_COMMON: 3,
	TASK_ERROR: 4,
	LICENSE_WARNING: 5,
} as const);
